<template>
  <div
    class="h-full w-full rounded bg-white p-3 shadow-normal shadow-gray-400 tablet:p-4 desktop:p-5"
  >
    <div class="mb-2 flex items-center tablet:block">
      <figure
        class="h-[46px] w-[46px] basis-[46px] tablet:h-[78px] tablet:w-[78px] tablet:basis-[78px] desktop:h-20 desktop:w-20 desktop:basis-20"
      >
        <img
          :src="contextThumbnail"
          :alt="itemData.name || itemData.description"
          loading="lazy"
          class="pointer-events-none block h-full w-full"
        />
      </figure>
      <h3
        class="line-clamp-2 flex-1 pl-3 text-sm font-bold leading-6 tablet:pl-0 tablet:text-base"
      >
        {{ itemData.name }}
      </h3>
    </div>

    <p
      class="w-full text-sm text-gray-600 tablet:line-clamp-4"
      :class="contextExpand && 'mb-6'"
    >
      {{ itemData.description }}
    </p>

    <ul v-if="contextExpand">
      <li
        v-for="link in itemData.links"
        :key="hash(link)"
        class="mb-6 last:mb-0"
      >
        <h4 class="mb-2">
          <TheNuxtLink
            :id="link.trackingCode"
            :title="link.name"
            :to="provideFormatUrl(link.link)"
            class="line-clamp-2 text-sm font-bold leading-6 text-blue-400 underline"
          >
            {{ link.name }}
          </TheNuxtLink>
        </h4>
        <p class="mb-2 w-full text-sm text-gray-600 tablet:line-clamp-4">
          {{ link.description }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { IItem } from '@/components/Shared/Suite/ListIconFeature/index.vue';
  import type { TUrlConnector } from '@/components/Shared/Suite/type.ts';

  interface IProps {
    itemData: IItem;
    isExpand?: boolean;
    urlConnector?: TUrlConnector;
  }

  const props = withDefaults(defineProps<IProps>(), {
    isExpand: false,
    urlConnector: undefined,
  });

  const { isDesktop } = useScreen();
  const { provideFormatUrl } = useFormatUrl();
  const { provideResponsiveImgUrl } = useSolutionsData();

  const contextExpand = computed((): boolean => {
    if (isDesktop.value) {
      return props.isExpand;
    }
    return true;
  });

  const contextThumbnail = computed((): string => {
    const { thumbnail } = props.itemData;
    if (!thumbnail) return '';

    if (props.urlConnector === 'solution') {
      return provideResponsiveImgUrl(thumbnail);
    }
    return thumbnail;
  });
</script>
